module.exports = __webpack_public_path__ + "img/Saint Vincent and the Grenadines.20e49b7d.svg";